/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IRealTimeDataHttpService } from './real-time-data-http.service.interface';
import { IApiResponseDto, EReportTypeId } from '../../models';
import { environment } from '../../../../environments/environment';

@Injectable()
export class RealTimeDataHttpService implements IRealTimeDataHttpService {
  private readonly _rootUrl: string;

  constructor(private readonly _httpClient: HttpClient) {
    this._rootUrl = environment.config.endpoints.realTimeDataApiEndpoint;
  }

  public getLiveMapReportTicket(vehicleId: number, reportType: EReportTypeId): Observable<string> {
    const data = {
      VehicleId: vehicleId,
      ReportTypeId: reportType
    };

    return this._httpClient
      .post<IApiResponseDto<string>>(`${this._rootUrl}/Report/LiveMapReport/`, data)
      .pipe(map(response => response.Data));
  }
}
